import { POE_DEMO_GAME_CODE_LIST } from "@/pages/dashboard/_config/constant";
import { useMemo } from "react";
import { getLocale, shallowEqual, useIntl, useSelector } from "umi";

export default function useFunnelOptionsByFilter(filterValue: any, haveDate = false, defaultSelect: any) {
  const { formatMessage } = useIntl();
  const gameCode = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.game_code;
  }, shallowEqual);
  const isPoeDemo = POE_DEMO_GAME_CODE_LIST?.includes(gameCode);
  const isRegisterFunnel = window?.location.href?.includes('funnel/registerFunnel');
  const isPoeFunnel = isPoeDemo && isRegisterFunnel;
  
  return useMemo(() => {
    const getOptions = (filterValue: any, haveDate: boolean) => {
      const options = [];
      if (haveDate) {
        options.push(
          {
            value: 'date',
            disabled: true,
            text: formatMessage({ id: 'common_by_Date' }),
          }
        );
      } else {
        options.push(
          {
            value: 'accumulated',
            groupKey: 'accumulated',
            text: formatMessage({ id: 'common_Accumulated' }),
          }
        );
      }
      if (filterValue?.zone && getVisbile(defaultSelect, 'zone')) {
        options.push(
          {
            value: 'zone',
            groupKey: 'separated',
            text: formatMessage({ id: 'common_by_Zone' }),
          }
        );
      }

      if (filterValue?.region && getVisbile(defaultSelect, 'region')) {
        options.push(
          {
            value: 'region',
            groupKey: 'separated',
            text: formatMessage({ id: 'common_by_Region' }),
          }
        );
        options.push(
          {
            value: 'country',
            groupKey: 'separated',
            text: formatMessage({ id: 'common_by_Country' }),
          }
        );
      }

      if (filterValue?.system && getVisbile(defaultSelect, 'system')) {
        options.push(
          {
            value: 'system',
            groupKey: 'separated',
            text: formatMessage({ id: 'common_by_System' }),
          }
        );
      }

      if (filterValue?.channel && getVisbile(defaultSelect, 'channel')) {
        options.push(
          {
            value: 'channel',
            groupKey: 'separated',
            text: isPoeFunnel ? formatMessage({ id: 'common_by_Channel_poe' }) :  formatMessage({ id: 'common_by_Channel' }),
          }
        );
      }
      if (filterValue?.lang && getVisbile(defaultSelect, 'lang')) {
        options.push(
          {
            value: 'language',
            groupKey: 'separated',
            text: isPoeFunnel ? formatMessage({ id: 'common_by_Language_poe' }) : formatMessage({ id: 'common_by_Language' }),
          }
        );
      }
      if (filterValue?.appVersion && getVisbile(defaultSelect, 'app_version')) {
        options.push(
          {
            value: 'app_version',
            groupKey: 'separated',
            text: isPoeFunnel ? formatMessage({ id: 'funnel_by_app_version_poe' }) : formatMessage({ id: 'funnel_by_app_version' }),
          }
        );
      }
      if (filterValue?.networkType && getVisbile(defaultSelect, 'network')) {
        options.push(
          {
            value: 'network_type',
            groupKey: 'separated',
            text: isPoeFunnel ? formatMessage({ id: 'funnel_by_network_type_poe' }) : formatMessage({ id: 'funnel_by_network_type' }),
          }
        );
      }
      if (filterValue?.memory && getVisbile(defaultSelect, 'memory')) {
        options.push(
          {
            value: 'memory',
            groupKey: 'separated',
            text: isPoeFunnel ? formatMessage({ id: 'funnel_by_memory_poe' }) : formatMessage({ id: 'funnel_by_memory' }),
          }
        );
      }
      if (filterValue?.storeChannel && getVisbile(defaultSelect, 'store_channel')) {
        options.push(
          {
            value: 'store_channel',
            groupKey: 'separated',
            text: formatMessage({ id: 'funnel_by_store_channel' }),
          }
        );
      }
      if (filterValue?.ua_network && getVisbile(defaultSelect, 'ua_network')) {
        options.push(
          {
            value: 'ua_network',
            groupKey: 'separated',
            text: formatMessage({ id: 'common_by_ua_network' }),
          }
        );
      }
      if (filterValue?.campaign && getVisbile(defaultSelect, 'campaign')) {
        options.push(
          {
            value: 'campaign',
            groupKey: 'separated',
            text: formatMessage({ id: 'common_by_campaign' }),
          }
        );
      }
      if (filterValue?.ab_test && getVisbile(defaultSelect, 'ab_test')) {
        options.push(
          {
            value: 'ab_test',
            groupKey: 'separated',
            text: formatMessage({ id: 'common_by_ab_test' }),
          }
        );
      }
      return options;
    };
    if (filterValue?.newFilter) {
      const { filterValue: filterVal } = filterValue ?? {};
      return getOptions(filterVal, haveDate);
    }
    return getOptions(filterValue, haveDate);
  }, [getLocale(), filterValue, defaultSelect]);
}

const getVisbile = (defaultSelect: any, key: string) => {
  if (!defaultSelect && key !== 'store_channel') return true;
  return defaultSelect?.find((item: { key: string; }) => item?.key === key)?.visible;
};